export const DEFAULT_ICONS = [
	'mdiBellRingOutline',
	'mdiCloudOutline',
	'mdiCurrencyUsd',
	'mdiAccountOutline',
	'mdiSkullOutline',
	'mdiCogOutline',
	'mdiRocketOutline',
	'mdiWalletGiftcard',
	'mdiHammerWrench',
	'mdiAccountPlusOutline',
	'mdiAccountSearchOutline',
	'mdiAlertCircleOutline',
	'mdiFolderAlertOutline',
	'mdiVectorArrangeBelow',
	'mdiWalletGiftcard',
	'mdiCreditCardOutline',
	'mdiLockOutline',
	'mdiEmailEditOutline',
	'mdiLockOutline',
	'mdiMonitor',
	'mdiTimerSandEmpty',
	'mdiReload',
	'mdiStarSettingsOutline',
	'mdiTicketConfirmationOutline',
	'mdiToolboxOutline',
	'mdiPinwheelOutline',
	'mdiSpaOutline',
	'mdiPigVariantOutline',
	'mdiMicrophoneOutline',
	'mdiMailboxOpenOutline',
	'mdiFlipToFront',
	'mdiTrayArrowDown',
	'mdiTrayArrowUp',
	'mdiShareOutline',
	'mdiLabelOutline',
	'mdiLightbulbOnOutline',
	'mdiLink',
	'mdiClockOutline',
	'mdiBankOutline',
	'mdiFileEditOutline',
	'mdiCalendarBlankOutline',
	'mdiShieldOutline',
];

export const DEFAULT_EMOJIS = [
	'wrapped_gift',
	'sparkles',
	'fireworks',
	'umbrella_on_ground',
	'sun_behind_cloud',
	'person_facepalming',
	'man_shrugging',
	'mechanic',
];
